/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type ListTotalNewAccountsPerDayResponse = {
  data: Array<Array<number>>;
};

/** @internal */
export const ListTotalNewAccountsPerDayResponse$inboundSchema: z.ZodType<
  ListTotalNewAccountsPerDayResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  data: z.array(z.array(z.number().int())),
});

/** @internal */
export type ListTotalNewAccountsPerDayResponse$Outbound = {
  data: Array<Array<number>>;
};

/** @internal */
export const ListTotalNewAccountsPerDayResponse$outboundSchema: z.ZodType<
  ListTotalNewAccountsPerDayResponse$Outbound,
  z.ZodTypeDef,
  ListTotalNewAccountsPerDayResponse
> = z.object({
  data: z.array(z.array(z.number().int())),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListTotalNewAccountsPerDayResponse$ {
  /** @deprecated use `ListTotalNewAccountsPerDayResponse$inboundSchema` instead. */
  export const inboundSchema = ListTotalNewAccountsPerDayResponse$inboundSchema;
  /** @deprecated use `ListTotalNewAccountsPerDayResponse$outboundSchema` instead. */
  export const outboundSchema =
    ListTotalNewAccountsPerDayResponse$outboundSchema;
  /** @deprecated use `ListTotalNewAccountsPerDayResponse$Outbound` instead. */
  export type Outbound = ListTotalNewAccountsPerDayResponse$Outbound;
}

export function listTotalNewAccountsPerDayResponseToJSON(
  listTotalNewAccountsPerDayResponse: ListTotalNewAccountsPerDayResponse,
): string {
  return JSON.stringify(
    ListTotalNewAccountsPerDayResponse$outboundSchema.parse(
      listTotalNewAccountsPerDayResponse,
    ),
  );
}

export function listTotalNewAccountsPerDayResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListTotalNewAccountsPerDayResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListTotalNewAccountsPerDayResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListTotalNewAccountsPerDayResponse' from JSON`,
  );
}
